import { PathOptions } from "leaflet";

export const uhe_base_existente = (feature: any): PathOptions => {
  return {
    color: "#006400",
    weight: 2,
    opacity: 1,
    fillColor: "#228B22",
    fillOpacity: 0.6,
  };
};
